import type {HostMap} from '../../../types'

export const UNSTABLE = {
  account: 'delivery-frontend-account-yango.delivery.dev.yandex.net',
  auth: 'delivery-frontend-auth-yango.delivery.dev.yandex.net',
  route: 'ddelivery-frontend-route-yango.delivery.dev.yandex.net',
} as const satisfies HostMap
